// extracted by mini-css-extract-plugin
export var attachment = "_qj-a";
export var emailContainer = "_qj-4";
export var emailContentPaddedContainer = "_qj-b";
export var emailHeader = "_qj-6";
export var emailIframe = "_qj-3";
export var emailInfoIcon = "_qj-9";
export var emailShortenedSummary = "_qj-e";
export var infoDropdown = "_qj-0";
export var infoRowBoundedContent = "_qj-d";
export var internal = "_qj-5";
export var merchant = "_qj-8";
export var messageInputContainer = "_qj-h";
export var normal = "_qj-7";
export var replyCard = "_qj-f";
export var subtleButton = "_qj-1";
export var subtleButtonIconContainer = "_qj-2";
export var toggleViewRepliesButton = "_qj-c";
export var wrappingText = "_qj-g";